export default __webpack_public_path__ + "static/media/logo-bayadIP@157x126.f60aae31.png";